// ═══════════════════════════════════════════════════════════
// API 数据源配置 — 项目的唯一配置源
// 添加/删除/修改源只需编辑此文件，构建时自动同步到：
//   - functions/_shared/config.js (Cloudflare Functions)
//   - dist/assets/app.js (前端)
//   - 设置面板的 <select> 选项（动态生成）
// ═══════════════════════════════════════════════════════════

export const API_SITES = {
    hnzy: {
        api: 'https://www.hongniuzy2.com',
        name: '红牛资源',
        desc: '1080P 高码率',
        active: true,
    },
    hyzy: {
        api: 'https://www.huyaapi.com',
        name: '虎牙资源',
        desc: '动漫专精 1080P',
        active: true,
    },
    lzzy: {
        api: 'https://cj.lziapi.com',
        name: '量子资源',
        active: true,
    },
    zy360: {
        api: 'https://360zy.com',
        name: '360资源',
        active: true,
    },
    ffzy: {
        api: 'http://ffzy5.tv',
        name: '非凡影视',
        active: true,
    },
    ffcj: {
        api: 'http://cj.ffzyapi.com',
        name: '非凡采集',
        active: true,
    },
};

// 网站基本信息
export const SITE_CONFIG = {
    name: 'LibreTV',
    url: 'https://libretv-ap8.pages.dev',
    description: '免费在线视频搜索与观看平台',
    version: '2.0.0',
};

// API 请求配置
export const API_CONFIG = {
    search: {
        path: '/api.php/provide/vod/?ac=videolist&wd=',
    },
    detail: {
        path: '/api.php/provide/vod/?ac=videolist&ids=',
    },
};

// 获取活跃的源列表（用于 UI 渲染）
export function getActiveSites() {
    return Object.entries(API_SITES)
        .filter(([, site]) => site.active)
        .map(([key, site]) => ({ key, ...site }));
}

// 获取源名称
export function getSiteName(key) {
    return API_SITES[key]?.name || key;
}

// 获取 API 域名列表（用于安全校验）
export function getAllowedDomains() {
    return Object.values(API_SITES)
        .filter(s => s.active)
        .map(s => new URL(s.api).hostname);
}
